import React from 'react'
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import placeholder from '../img/placeholder.png'
import {Col, Row} from 'react-bootstrap'
import './MyCommunitiesCard.css'

const MyCommunitiesCard = (props) => {

    return (
      <div className='myComCard'>
        <Card sx={{ width: 225 }}>
          <CardMedia
            component="img"
            height="100"
            image={props.imageUrl}
          />
        <CardContent>
          <Typography gutterBottom variant="h7" component="div">
            <Row>
            <Col style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
            <Link to={`/community/${props.url}`} style={{color: 'black',
            textDecoration: 'none'}}>
            <p className='cardGroupName'>
              {props.groupName}
            </p>
            </Link>
            </Col>
            <Col xs={2}> 
            {props.admin == "isAdmin"? 
            <StarIcon style={{float:"right"}}/>
            : 
            null}
            </Col>
            </Row>
          </Typography>
        </CardContent>
        </Card>
      </div>
    );
  }

MyCommunitiesCard.defaultProps = {
  groupName : "Group Name",
  url : "",
  imageUrl : placeholder,
  admin: "notAdmin"
}
  export default MyCommunitiesCard